import type { ArticleCategory } from "@brookbush/types";

import CardGrid from "~/components/CardGrid";
import Carousel from "~/components/Carousel";
import LoadingAnimation from "~/components/LoadingAnimation";
import ArticlesCard from "~/pages/articles/components/ArticlesCard";

interface ArticlesCategoryProps {
	category: ArticleCategory;
}
const ArticlesCategory = ({ category }: ArticlesCategoryProps) => {
	if (!category)
		return (
			<div className="flex h-[75vh] items-center justify-center">
				<LoadingAnimation />
			</div>
		);

	return (
		<div className="mt-4 flex w-full flex-col gap-4 phablet:gap-6">
			<h1 className="phablet:text-left text-center font-semibold laptop:text-3xl phablet:text-3xl text-2xl xl:-mt-1">
				{category.title}
			</h1>
			{category.subCategories?.length ? (
				<div className="flex w-full flex-col gap-4">
					{category
						.subCategories!.toSorted((a, b) => a.title.localeCompare(b.title))
						.map((subCategory) => (
							<Carousel
								hasMore
								title={subCategory.title}
								key={subCategory._key}
								href={`/articles/categories/${category.slug}/${subCategory.slug}`}
							>
								{subCategory.articles?.length > 0 ? (
									subCategory.articles?.map((article) => (
										<ArticlesCard key={article._id} {...article}></ArticlesCard>
									))
								) : (
									<div className="flex h-26 w-full items-center justify-center">
										<h4 className="font-semibold text-md">No Articles Found</h4>
									</div>
								)}
							</Carousel>
						))}
				</div>
			) : category.articles?.length ? (
				<CardGrid>
					{category.articles?.map((article) => (
						<div className="card-grid-node-basis" key={article._id}>
							<ArticlesCard {...article}></ArticlesCard>
						</div>
					))}
				</CardGrid>
			) : (
				<div className="flex h-[calc(100vh-20rem)] w-full items-center justify-center">
					<h2 className="font-semibold phablet:text-2xl text-xl">
						No Articles Found
					</h2>
				</div>
			)}
		</div>
	);
};

export default ArticlesCategory;
